export const submissions = [
  {
    lastName: "Bensalem",
    firstName: "Karim",
    phone: "0551234567",
    function: "Agriculteur",
    company: "Ferme du Sud",
    hectares: 35,
    wilaya: 16,
    commune: 16001,
    cultures: ["cereales", "legumes"]
  },
  {
    lastName: "Chouikh",
    firstName: "Amine",
    phone: "0569876543",
    function: "Ingénieur Agronome",
    company: "AgriTech",
    hectares: 12,
    wilaya: 31,
    commune: 31005,
    cultures: ["arbres-fruitiers"]
  },
  {
    lastName: "Abdelkader",
    firstName: "Yasmine",
    phone: "0770123456",
    function: "Technicienne",
    company: "BioFarm",
    hectares: 20,
    wilaya: 22,
    commune: 22007,
    cultures: ["cereales", "pomme-de-terre"]
  },
  {
    lastName: "Meziane",
    firstName: "Nabil",
    phone: "0553322110",
    function: "Producteur",
    company: "Ferme Meziane",
    hectares: 50,
    wilaya: 25,
    commune: 25010,
    cultures: ["legumes", "arbres-fruitiers"]
  },
  {
    lastName: "Rahmani",
    firstName: "Sonia",
    phone: "0772345678",
    function: "Responsable Qualité",
    company: "AgriPlus",
    hectares: 8,
    wilaya: 19,
    commune: 19002,
    cultures: ["cereales"]
  },
  {
    lastName: "Mekki",
    firstName: "Omar",
    phone: "0667788990",
    function: "Agriculteur",
    company: "Ferme Mekki",
    hectares: 100,
    wilaya: 7,
    commune: 7001,
    cultures: ["pomme-de-terre", "legumes"]
  },
  {
    lastName: "Saidi",
    firstName: "Hafsa",
    phone: "0559873210",
    function: "Chef Exploitation",
    company: "GreenLand",
    hectares: 45,
    wilaya: 13,
    commune: 13003,
    cultures: ["arbres-fruitiers", "cereales"]
  },
  {
    lastName: "Lounis",
    firstName: "Walid",
    phone: "0775554443",
    function: "Ingénieur",
    company: "AgriSmart",
    hectares: 25,
    wilaya: 9,
    commune: 9001,
    cultures: ["legumes", "arbres-fruitiers"]
  },
  {
    lastName: "Zeroual",
    firstName: "Meriem",
    phone: "0564443322",
    function: "Conseillère",
    company: "Ferme Ouest",
    hectares: 5,
    wilaya: 12,
    commune: 12008,
    cultures: ["pomme-de-terre"]
  },
  {
    lastName: "Amrane",
    firstName: "Hichem",
    phone: "0556677889",
    function: "Agriculteur",
    company: "AgroCoop",
    hectares: 75,
    wilaya: 4,
    commune: 4002,
    cultures: ["cereales", "arbres-fruitiers"]
  },
  {
    lastName: "Boukhalfa",
    firstName: "Samira",
    phone: "0779998887",
    function: "Technicienne",
    company: "BioFerme",
    hectares: 15,
    wilaya: 21,
    commune: 21006,
    cultures: ["legumes"]
  },
  {
    lastName: "Gacem",
    firstName: "Karima",
    phone: "0553332221",
    function: "Productrice",
    company: "AgriKarim",
    hectares: 30,
    wilaya: 2,
    commune: 2003,
    cultures: ["arbres-fruitiers"]
  },
  {
    lastName: "Belkacem",
    firstName: "Farid",
    phone: "0665554442",
    function: "Exploitant",
    company: "Ferme du Centre",
    hectares: 40,
    wilaya: 18,
    commune: 18005,
    cultures: ["cereales", "legumes"]
  },
  {
    lastName: "Ouali",
    firstName: "Mounir",
    phone: "0774443331",
    function: "Agriculteur",
    company: "AgriFert",
    hectares: 60,
    wilaya: 33,
    commune: 33002,
    cultures: ["pomme-de-terre"]
  },
  {
    lastName: "Sahraoui",
    firstName: "Nora",
    phone: "0552221110",
    function: "Ingénieure",
    company: "Ferme Nora",
    hectares: 18,
    wilaya: 26,
    commune: 26001,
    cultures: ["legumes", "cereales"]
  },
  {
    lastName: "Hadjri",
    firstName: "Adel",
    phone: "0661112223",
    function: "Producteur",
    company: "AgroBio",
    hectares: 55,
    wilaya: 6,
    commune: 6004,
    cultures: ["arbres-fruitiers"]
  },
  {
    lastName: "Benali",
    firstName: "Souhila",
    phone: "0778887776",
    function: "Responsable Exploitation",
    company: "AgriPro",
    hectares: 22,
    wilaya: 15,
    commune: 15002,
    cultures: ["cereales"]
  },
  {
    lastName: "Kaci",
    firstName: "Ali",
    phone: "0556665554",
    function: "Agriculteur",
    company: "Ferme Ali",
    hectares: 90,
    wilaya: 17,
    commune: 17003,
    cultures: ["legumes", "pomme-de-terre"]
  },
  {
    lastName: "Cherif",
    firstName: "Fatima",
    phone: "0663332211",
    function: "Technicienne",
    company: "AgriSolutions",
    hectares: 10,
    wilaya: 10,
    commune: 10005,
    cultures: ["arbres-fruitiers"]
  },
  {
    lastName: "Hamdi",
    firstName: "Yacine",
    phone: "0771110009",
    function: "Agriculteur",
    company: "AgroStar",
    hectares: 28,
    wilaya: 8,
    commune: 8001,
    cultures: ["cereales", "legumes"]
  }
];